import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  scrollable: {
    type: 'boolean',
    default: false,
  },
  size: {
    type: 'int',
    default: 3,
  },
  vAlign: {
    type: 'string',
    default: 'v-top',
  },
  hAlign: {
    type: 'string',
    default: 'h-start',
  },
  ...Common,
};
